import { useQuery } from "react-query";
import { Queries } from "../../../constants/queries";
import { getDumpout } from "./getDumpout";
import { TDumpouts } from "./types";
import { t } from "i18next";
import { translations } from "../../../i18n/translations";
import { useToast } from "@chakra-ui/react";

export const useDumpout = () => {
  const toast = useToast();
  return useQuery<TDumpouts>(Queries.Dumpout, getDumpout(), {
    staleTime: Infinity,
    cacheTime: Infinity,
    onError: () => {
      toast({
        title: "Error",
        description: t<string>(translations.errors.jobs_error),
        status: "error",
        position: "top-right",
      });
    },
  });
};
